import { useEffect, useRef } from 'react'

import { databaseEffectsActions } from '../actions'
import { getReferenceTables } from '../utils/tableHelpers'
import { useActions, useAppSelector } from '../../../store/hooks'
import { authSelector } from '../../../store/slices/auth'
import { databasePageSelector } from '../../../store/slices/databasePage'
import { databaseSelector } from '../../../store/slices/database'

export function useDatabaseEffects() {
    const isAuthorized = useAppSelector(authSelector.isAuthorized)
    const selectedTable = useAppSelector(databasePageSelector.selectedTable)
    const adding = useAppSelector(databaseSelector.adding)
    const saving = useAppSelector(databaseSelector.saving)
    const addError = useAppSelector(databaseSelector.addError)
    const editError = useAppSelector(databaseSelector.editError)

    const {
        databaseLoadTable,
        databaseLoadOptions,
        clearErrors,
        resetFormData,
        cancelEditingRow,
    } = useActions(databaseEffectsActions)

    const prevAdding = useRef(false)
    const prevSaving = useRef(false)

    useEffect(() => {
        if (!isAuthorized) return

        clearErrors()
        resetFormData()
        cancelEditingRow()
        databaseLoadTable(selectedTable)
        databaseLoadOptions(getReferenceTables(selectedTable))
    }, [
        selectedTable,
        isAuthorized,
        databaseLoadTable,
        databaseLoadOptions,
        clearErrors,
        resetFormData,
        cancelEditingRow,
    ])

    useEffect(() => {
        if (prevAdding.current && !adding && !addError) {
            resetFormData()
        }

        prevAdding.current = adding
    }, [adding, addError, resetFormData])

    useEffect(() => {
        if (prevSaving.current && !saving && !editError) {
            cancelEditingRow()
        }

        prevSaving.current = saving
    }, [saving, editError, cancelEditingRow])
}
